let DATE_SECOND = 1000,
  DATE_MINUTE = 60 * DATE_SECOND,
  DATE_HOUR = 60 * DATE_MINUTE,
  DATE_DAY = 24 * DATE_HOUR,
  DATE_WEEK = 7 * DATE_DAY;

export {
  DATE_SECOND,
  DATE_MINUTE,
  DATE_HOUR,
  DATE_DAY,
  DATE_WEEK,
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/constants.ts